export const REQUESTS_ENROLLMENTS_SLICE_NAME = "requestsEnrollments"
